import React from 'react';
import styles from './styles.module.css';
import nhslogo from 'assets/nhs-providing.svg';
import { FooterContent } from 'services/content';

const UnifiedPlatformFooter = () => (
  <footer>
    <div className={styles.footer}>
      <div className={styles.footerContainer}>
        <div className={styles.footerUpperContainer}>
          <div className={styles.section1}>
            <h2 className={styles.heading}>Our pharmacy</h2>
            <address className={styles.address}>
              Rowlands Pharmacy Online
              <br />
              Rivington Road
              <br />
              Runcorn
              <br />
              Cheshire
              <br />
              WA7 3DJ
            </address>
            <p className={styles.address}>GPhC Registered Premises: 9011089</p>
          </div>
          <div className={styles.section2}>
            <h2 className={styles.heading}>Pharmacy Superintendent</h2>
            <p className={styles.superintendentParagraph}>
              Stephen Graham Thomas
              <br />
              GPhC number:&nbsp;
              <a
                className={styles.sectionLinks}
                href="https://www.pharmacyregulation.org/registers/pharmacist/registrationnumber/2043726">
                2043726
              </a>
            </p>
            <p className={styles.superintendentParagraph}>
              Email:{' '}
              <a className={styles.sectionLinks} href="mailto:help@heypharmacist.co.uk">
                help@heypharmacist.co.uk
              </a>
              <br />
              Phone: 01928&nbsp;761&nbsp;015
            </p>
          </div>
          <div className={styles.section3}>
            <div className={styles.nhsLogoContainer}>
              <img className={styles.nhsLogo} src={nhslogo} alt="providing NHS services badge" />
            </div>
            <div className={styles.logosContainer}>
              <a href="https://twitter.com/heypharmacist_">
                <svg xmlns="http://www.w3.org/2000/svg" className={styles.socialmediaIcon} viewBox="0 0 16 16">
                  <path d="M8 0a8 8 0 108 8 8 8 0 00-8-8zm4.08 6.11a.68.68 0 00-.26.55 5.51 5.51 0 01-1.37 3.52 5.41 5.41 0 01-6.65 1.08l-.1-.11a4.18 4.18 0 002.62-.8A2.1 2.1 0 014.6 9.08L5.38 9a2 2 0 01-1.46-1.85l.74.19a2.12 2.12 0 01-.5-2.53 5.63 5.63 0 003.91 2v-.45a1.78 1.78 0 011-1.7 1.74 1.74 0 011.94.18.59.59 0 00.66.11 2.93 2.93 0 01.79-.23l-.68.91.84-.21c-.13.26-.31.5-.54.69z"></path>{' '}
                </svg>
              </a>
              <a href="https://facebook.com/heypharmacistuk">
                <svg className={styles.socialmediaIcon} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                  <path d="M16 8a8 8 0 10-9.25 7.903v-5.59H4.719V8H6.75V6.237c0-2.005 1.194-3.112 3.022-3.112.875 0 1.79.156 1.79.156V5.25h-1.008c-.994 0-1.304.617-1.304 1.25V8h2.219l-.355 2.313H9.25v5.59A8.002 8.002 0 0016 8z"></path>{' '}
                </svg>
              </a>
              <a href="https://instagram.com/hey.pharmacist/">
                <svg xmlns="http://www.w3.org/2000/svg" className={styles.socialmediaIcon} viewBox="0 0 32 32">
                  <path d="M31.9 9.4c0-1.3-.3-2.6-.7-3.9-.4-1.1-1-2-1.8-2.8-.9-.9-1.8-1.4-2.8-1.8C25.4.4 24 .2 22.7.1 20.9 0 20.3 0 16 0c-4.3 0-4.9 0-6.6.1S6.5.4 5.5.8c-1.1.4-1.9 1-2.8 1.8-.9 1-1.4 1.9-1.9 2.9C.4 6.8.1 8.1.1 9.4 0 11.1 0 11.7 0 16s0 4.9.1 6.6c.1 1.7.3 2.9.7 3.9.4 1.1 1 1.9 1.8 2.8.9.9 1.8 1.4 2.8 1.8 1.2.5 2.6.7 3.9.7 1.8.2 2.4.2 6.7.2s4.9 0 6.6-.1c1.7-.1 2.9-.3 3.9-.7 1.1-.4 1.9-1 2.8-1.8.9-.9 1.4-1.8 1.8-2.8.5-1.2.7-2.6.7-3.9.2-1.8.2-2.4.2-6.7s0-4.9-.1-6.6zM29 22.5c0 1-.2 2-.5 3-.3.7-.7 1.3-1.2 1.8s-1.1.9-1.8 1.2c-.6.2-1.4.5-3 .6-1.7.1-2.2.1-6.5.1s-4.8 0-6.5-.1c-1 0-2-.2-3-.6-.7-.3-1.3-.7-1.8-1.2s-.9-1.1-1.2-1.8c-.2-.6-.5-1.5-.5-3-.1-1.7-.1-2.2-.1-6.5s0-4.8.1-6.5c0-1.5.3-2.4.5-2.9.3-.7.6-1.3 1.2-1.8.5-.5 1.1-.9 1.8-1.2.6-.3 1.5-.6 3-.6 1.7-.1 2.2-.1 6.5-.1s4.8 0 6.5.1c1.6.1 2.4.3 3 .5.7.3 1.3.6 1.8 1.2.5.5.9 1.1 1.2 1.8.2.6.5 1.5.5 3 .1 1.7.1 2.2.1 6.5s0 4.8-.1 6.5z"></path>{' '}
                  <path d="M16 7.8c-4.5 0-8.2 3.7-8.2 8.2s3.7 8.2 8.2 8.2 8.2-3.7 8.2-8.2-3.7-8.2-8.2-8.2zm0 13.5c-2.9 0-5.3-2.4-5.3-5.3s2.4-5.3 5.3-5.3 5.3 2.4 5.3 5.3-2.4 5.3-5.3 5.3z"></path>{' '}
                  <circle cx="24.5" cy="7.5" r="1.9"></circle>
                </svg>
              </a>
            </div>
            <div className={styles.legitIconContainer}>
              <a
                href="https://legitscript.com"
                title="Verify LegitScript Approval"
                target="_blank"
                rel="noopener noreferrer">
                <img
                  src="http://static.legitscript.com/seals/12643328.png"
                  alt="LegitScript approved"
                  width="140"
                  height="100"
                  border="0"
                />
              </a>
            </div>
          </div>
        </div>
        <div className={styles.footerLowerContainer}>
          <ul className={styles.footerMenu}>
            {FooterContent.map((item) => {
              return (
                <li key={item['data-linktext']} className={styles.footerMenuItem}>
                  <a
                    href={item.href}
                    className={styles.linkBlack}
                    role="menuitem"
                    data-contenttype="Footer"
                    data-contentparent={item['data-contentparent']}
                    data-linktext={item['data-linktext']}>
                    {item['data-linktext']}
                  </a>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </div>
  </footer>
);

export default UnifiedPlatformFooter;
